module.exports = __webpack_public_path__ + "static/media/HR.76967f53.svg";